export enum VendorBrand {
  CDVI = 'CDVI',
  PDK = 'PDK',
}
